<template>
  <div
    class="order-instructions mb-4"
    v-if="order.order_address_instructions || order.order_note"
  >
    <div class="mb-1" v-if="order.order_address_instructions">
      <h6 class="mb-0">
        {{ _T('Extra instructions') }}
      </h6>
      <h5 class="mt-1">{{ order.order_address_instructions }}</h5>
    </div>
    <div class="mt-3" v-if="order.order_note">
      <h6 class="mb-0">
        {{ _T('Order Note') }}
      </h6>
      <h5 class="mt-1">{{ order.order_note }}</h5>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrderInstructions',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.order-instructions {
  padding: $px10 $px20;
  border: $px1 solid $dark-border;
  border-radius: $px4;
  width: 100%;
  background-color: $white;
  div {
    h6 {
      font-weight: 600;
      line-height: $px22;
      letter-spacing: 0.005em;
      color: $light-font;
      margin-bottom: 0;
    }
    h5 {
      font-weight: 600;
    }
  }
}
</style>
